module.exports = __webpack_public_path__ + "img/icon-world.27d2a080.png";